import { Link } from "react-router-dom";
import Seo from "../Components/Seo.jsx";
import PageHeader from "../Components/PageHeader.jsx";
import { EnquiryCta, VenueCard } from "../Components/SiteInfo.jsx";

const PATH = "/enrolment/";

const steps = [
  {
    title: "Verify your mobile number",
    text: "When you open the expression of interest form, we send a one-time code to your mobile to confirm it is you.",
  },
  {
    title: "Tell us about your family",
    text: "Enter your contact details and address, then add each child's name, their mainstream school and year, and the WSTSC level you are interested in.",
  },
  {
    title: "We email you the next steps",
    text: "Our team reviews your application and emails you the rest of the enrolment details.",
  },
];

const Enrolment = () => (
  <>
    <Seo path={PATH} />
    <PageHeader
      title="How to Enrol"
      breadcrumbs={[
        { label: "Home", href: "/", icon: "bi-house" },
        { label: "How to Enrol", active: true },
      ]}
    />

    <section className="py-5">
      <div className="container py-lg-4">
        <div className="row">
          <div className="col-lg-9">
            <p className="fs-5 mb-3">
              Enrolling your child at Western Sydney Tamil Study Centre starts
              with a short online expression of interest.
            </p>
            <p className="text-muted mb-0">
              The form asks for your contact details and a few details about
              each child. If you are unsure which level suits your child, call
              or email us before you start.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="py-5" style={{ background: "#f9f9f9" }}>
      <div className="container">
        <h2 className="fw-bold mb-4">Three steps to enrol</h2>
        <ol className="list-unstyled row g-4 mb-4">
          {steps.map((step, index) => (
            <li className="col-md-4" key={step.title}>
              <div className="h-100 bg-white border rounded-4 border-bottom-left p-4">
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle red-bg text-white fw-bold mb-3" style={{ width: 40, height: 40 }}>
                  {index + 1}
                </span>
                <h3 className="fs-5 fw-bold">{step.title}</h3>
                <p className="text-muted mb-0">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
        <Link
          to="/eoi/"
          className="btn red-bg text-white rounded-5 px-4 py-2 fs-6 custom-btn d-inline-flex align-items-center border-bottom-left"
        >
          Start the expression of interest
          <i className="bi bi-arrow-right ms-2" aria-hidden="true"></i>
        </Link>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-6">
            <h2 className="fw-bold mb-3">What to have ready</h2>
            <ul className="text-muted">
              <li>Your mobile phone, to receive the verification code</li>
              <li>Your email address and home address</li>
              <li>
                Each child's full name, the mainstream school they attend and
                their school year
              </li>
              <li>Any notes or questions you would like our team to know about</li>
            </ul>
          </div>
          <div className="col-lg-6">
            <h2 className="fw-bold mb-3">Fees, class times and term dates</h2>
            <p className="text-muted">
              Fees, class times and term dates are confirmed each year. Ask us
              for the current details before you enrol. We are happy to answer
              questions by phone or email.
            </p>
            <Link to="/programs/" className="green-text fw-semibold text-decoration-none">
              See what each learning stage covers
              <i className="bi bi-arrow-right ms-1" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>

    <section className="pb-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <VenueCard />
          </div>
        </div>
      </div>
    </section>

    <EnquiryCta heading="Questions before you enrol?" />
  </>
);

export default Enrolment;
